module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"diagram":"Diagram"},"fr":{"diagram":"Diagramme"}}')
  delete Component.options._Ctor
}
